// services/healthSystems.js
import axiosInstance from './axiosInstance';

const HEALTH_SYSTEMS_API_URL = '/health_systems';

const healthSystemsService = {
  // Obter todos os sistemas de saúde
  async get() {
    try {
      const response = await axiosInstance.get(`${HEALTH_SYSTEMS_API_URL}/get.php`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter sistemas de saúde:', error);
      return [];
    }
  }
};

export default healthSystemsService;
